const HowItWorks = () => {
  const steps = [
    {
      num: '1',
      icon: 'fas fa-user-plus',
      color: 'from-blue-500 to-indigo-600',
      bgColor: 'bg-blue-50',
      title: 'سجل حسابك',
      desc: 'دخل معلوماتك البسيطة وسجل في المنصة في أقل من دقيقة'
    },
    {
      num: '2',
      icon: 'fas fa-search',
      color: 'from-purple-500 to-pink-500',
      bgColor: 'bg-purple-50',
      title: 'اختار المحتوى',
      desc: 'شوف المحتوى المتاح واختار اش تحب تتعلم حسب اهتماماتك'
    },
    {
      num: '3',
      icon: 'fas fa-rocket',
      color: 'from-green-500 to-emerald-500',
      bgColor: 'bg-green-50',
      title: 'ابدأ التعلم',
      desc: 'ابدأ رحلتك التعليمية بالدارجة وتابع تقدمك خطوة بخطوة'
    }
  ];

  return (
    <section className="relative z-10 py-24 bg-gradient-to-b from-gray-50 to-white overflow-x-hidden" id="how">
      {/* Blue gradient blobs */}
      <div className="absolute top-20 right-0 w-40 h-40 md:w-56 md:h-56 lg:w-72 lg:h-72 bg-blue-500/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-10 left-10 w-48 h-48 md:w-64 md:h-64 lg:w-80 lg:h-80 bg-indigo-500/25 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 left-0 w-40 h-40 md:w-56 md:h-56 lg:w-72 lg:h-72 bg-secondary/5 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-4 relative z-10">
        {/* Section Header */}
        <div className="text-center max-w-[800px] mx-auto mb-20">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary/10 text-primary rounded-full mb-6 font-semibold text-sm">
            <i className="fas fa-lightbulb"></i>
            <span>كيفاش نخدمو</span>
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-text mb-6 leading-tight">
            ابدأ التعلم في <span className="text-primary">3 خطوات</span>
          </h2>
          <p className="text-xl md:text-2xl text-text2 leading-relaxed">
            بسيط، سريع، وسهل باش تبدأ رحلتك التعليمية درك
          </p>
        </div>

        {/* Steps */}
        <div className="max-w-[1100px] mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 relative">
            {steps.map((step, idx) => (
              <div
                key={idx}
                className="relative group"
              >
                {/* Card */}
                <div className="bg-white rounded-2xl md:rounded-3xl p-5 md:p-8 border-2 border-gray-100 hover:border-primary/30 transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl h-full flex flex-col">
                  {/* Number Circle */}
                  <div className="relative mb-4 md:mb-6 flex justify-center">
                    <div className={`relative w-20 h-20 md:w-32 md:h-32 bg-gradient-to-br ${step.color} rounded-full flex items-center justify-center shadow-xl transform transition-transform duration-300 group-hover:scale-110 group-hover:rotate-6`}>
                      {/* Number */}
                      <span className="text-3xl md:text-5xl font-black text-white">{step.num}</span>
                    </div>
                    
                    {/* Glow effect */}
                    <div className={`absolute inset-0 w-20 h-20 md:w-32 md:h-32 bg-gradient-to-br ${step.color} rounded-full blur-2xl opacity-20 group-hover:opacity-40 transition-opacity mx-auto`}></div>
                  </div>

                  {/* Badge */}
                  <div className="mb-3 md:mb-4 text-center">
                    <span className={`inline-block px-3 py-1 md:px-4 md:py-1.5 ${step.bgColor} text-xs md:text-sm font-bold rounded-lg`}>
                      الخطوة {step.num}
                    </span>
                  </div>

                  {/* Content */}
                  <div className="text-center flex-1 flex flex-col">
                    <h3 className="text-lg md:text-2xl lg:text-3xl font-black text-text mb-2 md:mb-4">
                      {step.title}
                    </h3>
                    <p className="text-sm md:text-lg text-text2 leading-relaxed flex-1">
                      {step.desc}
                    </p>
                  </div>

                  {/* Icon at bottom */}
                  <div className="mt-4 md:mt-6 flex justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                    <div className={`w-10 h-10 md:w-12 md:h-12 bg-gradient-to-br ${step.color} rounded-xl flex items-center justify-center text-white text-sm md:text-base`}>
                      <i className={step.icon}></i>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
